module.exports = __webpack_public_path__ + "img/star.009831bd.svg";